export default {
  spacing0: '0',
  spacing1: '0.25rem', // 4px
  spacing2: '0.5rem', // 8px
  spacing3: '0.75rem', // 12px
  spacing4: '1rem', // 16px
  spacing5: '1.5rem', // 24px
  spacing6: '2rem', // 32px
  spacing7: '2.5rem', // 40px
  spacing8: '3rem', // 48px
  spacing9: '4rem', // 64px
  spacing10: '5rem', // 80px
  spacing11: '6rem', // 96px
  spacing12: '8rem', // 128px
};
